const RegisterBirthDate = () => {
  const registerBirthDateInput = document.querySelector("#register-birth-date");

  if (registerBirthDateInput) {
    registerBirthDateInput.addEventListener('input', (event) => {
      let value = event.target.value.replace(/\D/g, '');

      if (value.length >= 1) {
        const day = parseInt(value.slice(0, 2), 10);
        if (day > 31) {
          value = '31'; 
        }
      }

      if (value.length >= 3) {
        let month = value.slice(2, 4);
        if (parseInt(month, 10) > 12) {
          month = '12'; 
        }
        value = `${value.slice(0, 2)}.${month}`;
      }

      if (value.length > 5) {
        value = value.slice(0, 5);
      }

      event.target.value = value; 
    });

    registerBirthDateInput.addEventListener('blur', (event) => {
      const value = event.target.value;
      const [day, month] = value.split('.');

      if (!day || !month || day.length !== 2 || month.length !== 2) {
        event.target.value = ''; 
      }
    });
  }
};

export default RegisterBirthDate;


